import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * CardWW1 (VISA/MC World Wide) API
 * Оплата международными банковскими картами в долларах
 */

/**
 * Получить конфигурацию cardww1 (курсы и лимиты)
 */
export const fetchCardWwConfig = async () => {
  try {
    const response = await apiService.makeRequest('/api/cardww1/')

    if (response.cardww1) {
      return response.cardww1
    }

    throw new Error('Invalid response format: cardww1 config not found')
  } catch (error) {
    console.error('Error fetching CardWW config:', error)
    throw error
  }
}

/**
 * Получить пакеты для cardww1 из общего списка тарифов /api/topup/
 */
export const fetchCardWwPackages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.cardww1 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching CardWW packages:', error)
    throw error
  }
}

const normalizeCardWwCreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'

  return response.error
}

/**
 * Создать платеж cardww1 по сумме в долларах
 */
export const createPaymentByDollars = async (dollars) => {
  try {
    const response = await apiService.makeRequest('/api/cardww1/', {
      method: 'POST',
      body: JSON.stringify({ dollar: dollars })
    })

    const normalizedError = normalizeCardWwCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW payment by dollars:', error)
    throw error
  }
}

/**
 * Создать платеж cardww1 по количеству кристаллов
 */
export const createPaymentByCrystals = async (crystals) => {
  try {
    const response = await apiService.makeRequest('/api/cardww1/', {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    const normalizedError = normalizeCardWwCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW payment by crystals:', error)
    throw error
  }
}

/**
 * Открыть ссылку на оплату cardww1 через Telegram WebApp API
 */
export const openCardWwPayment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'CardWW', paymentWindow)
}

export default {
  fetchCardWwConfig,
  fetchCardWwPackages,
  createPaymentByDollars,
  createPaymentByCrystals,
  openCardWwPayment
}
